<template>
  <VLayout column :class="!edit ? 'pb-3' : ''">
    <VFlex xs12>
      <VForm @submit.prevent="addNewVatLevel">
        <VCardTitle v-if="!edit" class="title">
          <span>Nova davčna stopnja</span>
        </VCardTitle>
        <VLayout row justify-space-around align-center>
          <VFlex xs3 pr-3>
            <NumberInput
              v-model="vatPercentage"
              label="Davčna stopnja (%)"
              :disabled="!vatSubject"
            />
          </VFlex>
          <VFlex xs3 pr-3>
            <NumberInput v-model="baseValue" :items="baseCandidates" label="Osnova za DDV" />
          </VFlex>
          <VFlex xs3>
            <NumberInput
              v-model="vatValue"
              :items="vatCandidates"
              label="Vrednost DDV"
              :disabled="!vatSubject"
            />
          </VFlex>
          <VFlex xs1 style="display: flex; align-items: center">
            <VBtn v-if="!edit" flat icon color="success" type="submit">
              <VIcon>done</VIcon>
            </VBtn>
            <VTooltip v-else-if="vatSubject" top>
              <VBtn slot="activator" icon flat color="red" @click="deleteAdditionalVat">
                <VIcon>delete</VIcon>
              </VBtn>
              <span>Zbriši davčno stopnjo</span>
            </VTooltip>
          </VFlex>
        </VLayout>
      </VForm>
    </VFlex>
  </VLayout>
</template>

<script>
import { generateInvKey, convertToFloatFormat } from '../helper';
import NumberInput from './inputs/NumberInput.vue';

export default {
  name: 'VatCard',
  components: {
    NumberInput,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
    additionalVats: {
      type: Array,
      default: () => [],
    },
    vatSubject: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      firstLoad: true,
      vatValue: null,
      baseValue: null,
      grossValue: null,
      vatPercentage: null,
      vatCandidates: [],
      baseCandidates: [],
      defaultObject: {
        vat: {
          percentage: '22',
          value: ['0.00'],
          found: true,
          validated: false,
          type: 'base',
        },
        net: {
          value: ['0.00'],
          found: true,
          validated: false,
        },
        gross: {
          value: ['0.00'],
          found: true,
          validated: false,
        },
      },
    };
  },
  watch: {
    vatPercentage(value) {
      if (!value) this.vatPercentage = '0.00';
      if (!this.firstLoad) {
        this.calculateVatValue();
      }
      if (this.edit && !this.firstLoad) {
        this.updateAdditionalVatObject();
      }
    },
    vatValue(value) {
      if (!value) this.vatValue = '0.00';
      if (!this.firstLoad) {
        this.calculateGrossValue();
      }
      if (this.edit && !this.firstLoad) {
        this.updateAdditionalVatObject();
      }
    },
    baseValue(value) {
      if (!value) this.baseValue = '0.00';
      if (!this.firstLoad) {
        this.calculateVatValue();
      }
      if (this.edit && !this.firstLoad) {
        this.updateAdditionalVatObject();
      }
    },
  },
  mounted() {
    if (this.data) {
      this.vatPercentage = this.data.vat.percentage;
      [this.vatValue] = this.data.vat.value;
      [this.baseValue] = this.data.net.value;
      this.vatCandidates = this.data.vat.value;
      this.baseCandidates = this.data.net.value;
    }
    this.$nextTick(() => {
      this.firstLoad = false;
    });
  },
  methods: {
    addNewVatLevel() {
      const vatObject = this._.cloneDeep(this.defaultObject);
      vatObject.vat.value[0] = parseFloat(convertToFloatFormat(this.vatValue)).toFixed(2);
      vatObject.vat.percentage = parseFloat(convertToFloatFormat(this.vatPercentage)).toFixed(2);
      vatObject.net.value[0] = parseFloat(convertToFloatFormat(this.baseValue)).toFixed(2);
      vatObject.gross.value[0] = parseFloat(convertToFloatFormat(this.grossValue)).toFixed(2);
      vatObject.id = generateInvKey();
      this.$emit('addNewVat', vatObject);
      this.vatPercentage = null;
      this.vatValue = null;
      this.baseValue = null;
    },
    calculateVatValue() {
      const vatPerc = parseFloat(convertToFloatFormat(this.vatPercentage));
      const baseValue = parseFloat(convertToFloatFormat(this.baseValue));
      const vatValue = baseValue * parseFloat(vatPerc / 100);
      this.vatValue = vatValue.toFixed(2);
      this.calculateGrossValue();
    },
    calculateGrossValue() {
      const baseValue = parseFloat(convertToFloatFormat(this.baseValue));
      const grossValue = baseValue + parseFloat(this.vatValue);
      this.grossValue = grossValue.toFixed(2);
    },
    deleteAdditionalVat() {
      this.$emit('onVatDelete', this.data.id);
    },
    updateAdditionalVatObject() {
      const vatObject = this._.cloneDeep(this.data);
      vatObject.vat.value[0] = this.vatValue;
      vatObject.vat.percentage = parseFloat(convertToFloatFormat(this.vatPercentage)).toFixed(2);
      vatObject.net.value[0] = parseFloat(convertToFloatFormat(this.baseValue)).toFixed(2);
      vatObject.gross.value[0] = parseFloat(convertToFloatFormat(this.grossValue)).toFixed(2);
      this.$emit('onVatChange', vatObject);
    },
  },
};
</script>

<style scoped></style>
